import { CoverageBenefitsHMODocuments } from 'consts'

export function getDocLink({
  authenticatedLinks,
  userHomeAddressState,
  documentName,
  planCoverageLevel,
}) {
  if (!authenticatedLinks || !authenticatedLinks[userHomeAddressState]) {
    return null
  }
  if (documentName === CoverageBenefitsHMODocuments.VIRTUAL_CARE_RIDER) {
    return (
      authenticatedLinks?.[userHomeAddressState]?.[documentName]?.[
        planCoverageLevel
      ] || ''
    )
  }
  return authenticatedLinks?.[userHomeAddressState]?.[documentName]
}
